export namespace AnalyticsNames {
    export const username = "username"
    export const request = "request"
    export const buttons = "buttons"
    export const ipaddress = "ipaddress"
    export const languages = "languages"
    export const banners = "banners"
    export const referral = "referral"
}